import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import masterCardImg from 'assets/img/illustrations/mastercard.png';
import visaImg from 'assets/img/illustrations/visaIcon.jpg';

const SelectorCompaniaTarjeta = ({ value, onChange }) => {
    return (
        <Form.Group className="mb-3">
            <Form.Label>Compa&ntilde;&iacute;a de la tarjeta</Form.Label>
            <div className="d-flex align-items-center">
                <Form.Select
                    value={value || ""}
                    onChange={(e) => onChange(e.target.value)}
                    className="me-2"
                >
                    <option value="">Sin especificar</option>
                    <option value="visa">Visa</option>
                    <option value="mastercard">MasterCard</option>
                </Form.Select>

                {value && (
                    <img
                        src={
                            value === "visa"
                                ? visaImg
                                : value === "mastercard"
                                    ? masterCardImg
                                    : "/static/media/ecommerce-bg.5fe9eaad590d4fdcfbbe.png"
                        }
                        alt={value}
                        width="40"
                        height="25"
                    />
                )}
            </div>
        </Form.Group>
    );
};

SelectorCompaniaTarjeta.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default SelectorCompaniaTarjeta;
